<template>
  <div class="event-units" v-if="this.items.length > 1">
    <select multiple @change="$emit('change', $event)" :size="selectSize">
      <option v-for="item in items" :key="item.id" :value="item.id" :title="item.nameFr+' ['+item.id+']'">{{ item.nameFr }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersEventEventUnits',
  computed: {
    items () {
      const filter = this.$store.getters['Sport/EventUnit/filtered']
      return this.$store.getters['Sport/EventUnit/list'].filter(item => filter.indexOf(item.id) > -1)
        .sort((a, b) => a.nameFr.localeCompare(b.nameFr))
    },
    selectSize () {
      return Math.min(this.items.length, 20)
    }
  }
}
</script>

<style scoped>
  .event-units{
    display:flex;
    align-items:center;
    margin-top:10px
  }
  .event-units > span{
    font-size:14px
  }
  .event-units > select{
    flex:0 0 100%
  }
</style>
